import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import LogoBox from "@/components/stickers/LogoBox";
import { api } from "@/lib/api";
import { applyUi, getUi } from "@/lib/uiSettings";

const ACCENTS = ["#3b82f6", "#06b6d4", "#10b981", "#f59e0b", "#ef4444", "#ec4899", "#8b5cf6", "#64748b"];

export default function BrandingTab({ ui, onSave }) {
  const [v, setV] = useState(ui);
  const [logo, setLogo] = useState(null);
  useEffect(() => { setV(ui); }, [ui]);
  useEffect(() => { api.get("/branding/logo", { responseType: "blob" }).then((r) => setLogo(URL.createObjectURL(r.data))).catch(() => setLogo(null)); return () => applyUi(getUi()); }, []);
  const set = (p) => { const n = { ...v, ...p }; setV(n); applyUi(n); };

  return (
    <div className="grid lg:grid-cols-2 gap-6 max-w-5xl" data-testid="branding-tab">
      <div className="border rounded-lg bg-card p-5 space-y-5">
        <div className="space-y-1.5"><Label htmlFor="app-name-input">App name (shown in the menu and browser tab)</Label>
          <Input id="app-name-input" maxLength={40} value={v.app_name} onChange={(e) => set({ app_name: e.target.value })} data-testid="app-name-input" /></div>
        <div className="space-y-2"><Label>Accent colour (buttons, highlights)</Label>
          <div className="flex flex-wrap items-center gap-2">
            {ACCENTS.map((c) => (
              <button key={c} type="button" onClick={() => set({ accent: c })} aria-label={c} data-testid={`accent-${c.slice(1)}`}
                className={`h-8 w-8 rounded-full border-2 transition-transform hover:scale-110 ${v.accent === c ? "border-white" : "border-transparent"}`} style={{ background: c }} />
            ))}
            <input type="color" value={v.accent} onChange={(e) => set({ accent: e.target.value })} className="h-8 w-10 cursor-pointer rounded border bg-transparent" data-testid="accent-picker" />
          </div>
          <div className="flex gap-2 pt-1"><Button size="sm">Preview button</Button><span className="text-sm text-primary self-center">Preview link colour</span></div>
        </div>
        <label className="flex items-center gap-3 text-sm"><Switch checked={v.show_logo !== false} onCheckedChange={(c) => set({ show_logo: c })} data-testid="show-logo-switch" /> Show my logo in the menu</label>
        <Button onClick={() => onSave(v)} disabled={!v.app_name.trim()} data-testid="branding-save"><Save size={14} /> Save branding</Button>
      </div>
      <div className="space-y-3">
        <LogoBox logo={logo} setLogo={(l) => { setLogo(l); window.dispatchEvent(new Event("logo-changed")); }} />
        <p className="text-xs text-muted-foreground">The same logo is used on stickers and can be placed on invoices in the invoice layout editor.</p>
      </div>
    </div>
  );
}
